import { QueryParamsEntities } from "./MainApp";
import { Pagination, PaginationV2 } from "./Pagination";
import formatDate from "@/app/infrastructures/misc/common-library/FormatDate";
import formatDateWithoutTime from "@/app/infrastructures/misc/common-library/FormatDateWithoutTime";
import formatDateBasedTimezoneValue from "@/app/infrastructures/misc/common-library/FormatDateBasedTimezoneValue"
import formatDateNormal from "@/app/infrastructures/misc/common-library/FormatDateNormal"

export class UrgentDeliveryManagementPODList {
  data: UrgentDeliveryManagementPODData[];
  pagination: Pagination;

  constructor(data: UrgentDeliveryManagementPODData[], pagination: Pagination) {
    this.data = data;
    this.pagination = pagination;
  }

}

export class UrgentDeliveryManagementPODData {
  pdId = 0;
  pdSTTNo = "";
  pdFlag = "";
  sttDeliveryType = "";
  pdReason = "";
  pdDeadlineReturn = "";
  sttLastReturnId = "";
  sttDestinationCity = "";
  sttRecipientName = "";
  sttRecipientPhone = "";
  sttDestinationCityName = "";
  sttDestinationDistrictName = "";
  deliveryDEXAttempt = 0;
  pdCreatedAt = "";
  pdUpdatedAt = "";
  pdProductType = "";
  pdCreatedName = "";
  pdCreatedRoleName = "";
  sttBookedAt = "";
  sttBookedName = "";
  pdAgingDays = 0;
  cityCode = "";
  hubId = 0;
  hubName = "";
  stationBucket = "";
  lastLocationLabel = "";

  constructor(fields?: Partial<UrgentDeliveryManagementPODData>) {
    Object.assign(this, fields);
  }

  get formatCreatedAt() {
    return formatDate(this.pdCreatedAt);
  }

  get formatBookedAt() {
    return formatDate(this.sttBookedAt);
  }

  get createdBy() {
    const nameActor = this.pdCreatedName || "";
    const roleActor = this.pdCreatedRoleName || "";

    if (nameActor.toLowerCase() === "system") return nameActor;
    if (nameActor && roleActor) return `${nameActor}.<br>${roleActor}`;
    if (!roleActor) return nameActor;

    return "";
  }

  get bookedBy() {
    const nameActor = this.sttBookedName || "";

    if (nameActor.toLowerCase() === "system") return nameActor;
    if (nameActor) return nameActor;

    return "";
  }

  get formatAgingDays() {
    return this.pdAgingDays > 0 ? `${this.pdAgingDays} hari` : "Hari ini";
  }
}

export interface LastLocationOptionValue {
  cityCode: string;
  hubId: number;
}

export interface LastLocationOption {
  name: string;
  value: LastLocationOptionValue;
}

export class UrgentDeliveryManagementPODListRequest {
  sttNo = "";
  sortBy = "";
  page = 1;
  limit = 20;
  isTotalData = true;
  flags = "";
  productType = "";
  startDate = "";
  endDate = "";
  sortColumn = "";
  cityCode = "";
  hubId = "";

  constructor(fields?: Partial<UrgentDeliveryManagementPODListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class UrgentDeliveryManagementPODListRequestDownload {
  sttNo = "";
  sortBy = "";
  startDate = "";
  endDate = "";
  flags = "";
  productType = "";
  sortColumn = "";
  cityCode = "";
  hubId = "";

  constructor(
    fields?: Partial<UrgentDeliveryManagementPODListRequestDownload>
  ) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class UrgentDeliveryManagementPODSummaryData {
  prioritShipment = 0;
  overSlaLimit = 0;
  redelivery = 0;
  noFlag = 0;

  constructor(fields?: Partial<UrgentDeliveryManagementPODSummaryData>) {
    Object.assign(this, fields);
  }
}

export class UrgentDeliveryManagementPODSummaryRequest {
  productType = "";
  startDate = "";
  endDate = "";
  cityCode = "";
  hubId = "";

  constructor(fields?: Partial<UrgentDeliveryManagementPODSummaryRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}


export class UrgentDeliveryManagementRTSList {
  data: UrgentDeliveryManagementRTSData[];
  pagination: Pagination;

  constructor(data: UrgentDeliveryManagementRTSData[], pagination: Pagination) {
    this.data = data;
    this.pagination = pagination;
  }

}

export class UrgentDeliveryManagementRTSData {
  pdId = 0;
  pdSTTNo = "";
  pdFlag = "";
  sttDeliveryType = "";
  pdCaseType = "";
  pdReason = "";
  pdDeadlineReturn = "";
  sttLastStatusId = "";
  sttOriginCityId = "";
  sttOriginCityName = "";
  sttDestinationCityId = "";
  sttDestinationCityName = "";
  pdCreatedAt = "";
  pdUpdatedAt = "";
  pdProductType = "";
  pdCreatedName = "";
  pdCreatedRoleName = "";
  pdDexCustomerAttempt = 0;
  pdBkdDate = "";
  pdBkdByName = "";
  pdBkdByRole = "";
  pdFlaggedDate = "";
  pdFlaggedByName = "";
  pdFlaggedByRole = "";
  sttClientAggregatorType = "";
  cityCode = "";
  hubId = 0;
  hubName = "";
  stationBucket = "";
  lastLocationLabel = "";

  constructor(fields?: Partial<UrgentDeliveryManagementRTSData>) {
    Object.assign(this, fields);
  }

  get formatCreatedAt() {
    return formatDate(this.pdCreatedAt);
  }

  get formatBkdDate() {
    return formatDate(this.pdBkdDate);
  }

  get formatFlaggedDate() {
    return formatDate(this.pdFlaggedDate);
  }

  get createdBy() {
    const nameActor = this.pdCreatedName || "";
    const roleActor = this.pdCreatedRoleName || "";

    if (nameActor.toLowerCase() === "system") return nameActor;
    if (nameActor && roleActor) return `${nameActor}.<br>${roleActor}`;
    if (!roleActor) return nameActor;

    return "";
  }
}

export class UrgentDeliveryManagementRTSListRequest {
  sttNo = "";
  sortBy = "";
  caseType = "";
  page = 1;
  limit = 20;
  isTotalData = true;
  productType = "";
  startDate = "";
  endDate = "";
  sortColumn = "";
  sttClientAggregatorType = "";
  cityCode?: string = "";
  hubId?: string = "";

  constructor(fields?: Partial<UrgentDeliveryManagementRTSListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class UrgentDeliveryManagementRTSListRequestDownload {
  sttNo = "";
  sortBy = "";
  caseType = "";
  productType = "";
  sortColumn = "";
  startDate = "";
  endDate = "";
  sttClientAggregatorType = "";
  cityCode?: string = "";
  hubId?: string = "";

  constructor(
    fields?: Partial<UrgentDeliveryManagementRTSListRequestDownload>
  ) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class UrgentDeliveryManagementMissingListRequestDownload {
  sttNo = "";
  sortBy = "";
  caseType = "";
  productType: string | string[] = "";
  sortColumn = "";
  startDate = "";
  endDate = "";
  sttType: string | string[] = "";
  cityCode = "";
  hubId = "";

  constructor(
    fields?: Partial<UrgentDeliveryManagementMissingListRequestDownload>
  ) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    const query = new QueryParamsEntities({
      sttNo: this.sttNo,
      sortBy: this.sortBy,
      caseType: this.caseType,
      sortColumn: this.sortColumn,
      startDate: this.startDate,
      endDate: this.endDate,
      cityCode: this.cityCode,
      hubId: this.hubId
    }).queryString;

    const params = new URLSearchParams(query);

    if (Array.isArray(this.productType)) {
      this.productType.forEach((value: string) => {
        params.append("product_type", value);
      });
    } else if (this.productType) {
      params.append("product_type", this.productType);
    }

    if (Array.isArray(this.sttType)) {
      this.sttType.forEach((value: string) => {
        params.append("stt_type", value);
      });
    } else if (this.sttType) {
      params.append("stt_type", this.sttType);
    }

    return params.toString();
  }
}

export class UrgentDeliveryManagementHALList {
  data: UrgentDeliveryManagementHALData[];
  pagination: Pagination;

  constructor(data: UrgentDeliveryManagementHALData[], pagination: Pagination) {
    this.data = data;
    this.pagination = pagination;
  }

}

export class UrgentDeliveryManagementTakenByRecipientList {
  data: UrgentDeliveryManagementTakenByRecipient[] = [];
  pagination: PaginationV2 = new PaginationV2();
  constructor(fields? : Partial<UrgentDeliveryManagementTakenByRecipientList>) {
    Object.assign(this, fields);
  }
}

export class UrgentDeliveryManagementHALData {
  pdId = 0;
  pdSTTNo = "";
  pdFlag = "";
  sttDeliveryType = "";
  pdCaseType = "";
  pdReason = "";
  pdDeadlineReturn = "";
  sttLastStatusId = "";
  sttOriginCityId = "";
  sttOriginCityName = "";
  sttDestinationCityId = "";
  sttDestinationCityName = "";
  pdCreatedAt = "";
  pdUpdatedAt = "";
  createdBy = "";
  cityCode = "";
  hubId = 0;
  hubName = "";
  stationBucket = "";
  lastLocationLabel = "";

  constructor(fields?: Partial<UrgentDeliveryManagementHALData>) {
    Object.assign(this, fields);
  }
}

export class UrgentDeliveryManagementTakenByRecipient {
  pdId = 0;
  pdSttNo = "";
  sttId = 0;
  sttProductType = "";
  sttIsCod = false;
  sttIsDfod = false;
  sttLastStatusId = "";
  sttDestinationCity = "";
  sttRecipientName = "";
  sttRecipientPhone = "";
  sttDestinationCityName = "";
  sttDestinationDistrictName = "";
  pdCreatedAt = "";
  pdUpdatedAt = "";
  constructor(fields?: Partial<UrgentDeliveryManagementTakenByRecipient>) {
    Object.assign(this, fields);
  }
}

export class UrgentDeliveryManagementHALListRequest {
  sttNo = "";
  sortBy = "";
  page = 1;
  limit = 20;
  isTotalData = true;
  cityCode = "";
  hubId = "";

  constructor(fields?: Partial<UrgentDeliveryManagementHALListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class UrgentDeliveryManagementHALListRequestDownload {
  sttNo = "";
  sortBy = "";
  cityCode = "";
  hubId = "";

  constructor(
    fields?: Partial<UrgentDeliveryManagementHALListRequestDownload>
  ) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class UrgentDeliveryManagementRelabelList {
  data: UrgentDeliveryManagementRelabelData[] = [];
  pagination: PaginationV2 = new PaginationV2();

  constructor(fields?: Partial<UrgentDeliveryManagementRelabelList>) {
    Object.assign(this, fields);
  }
}

export class UrgentDeliveryManagementRelabelData {
  pdId = 0;
  pdSttNo = "";
  rootReverseSttNo = "";
  processedBy = "";
  productType = "";
  overtimeDurationDays = 0;
  bkdAt = "";
  originHubName = "";
  originCityCode = "";
  destinationCityCode = "";
  originCityName = "";
  destinationCityName = "";

  constructor(fields?: Partial<UrgentDeliveryManagementRelabelData>) {
    Object.assign(this, fields);
  }

  get formatBkdAt() {
    return this.bkdAt ? formatDateBasedTimezoneValue(this.bkdAt) : "-";
  }

  // processed_by is the GENESIS-21333 machine enum (CONSOLIDATOR /
  // CLIENT_VIA_INTEGRATION), not the raw "aggregator" classification —
  // label follows the existing Aggregator/Non Aggregator convention used
  // by the urgent-rts sibling tab in this module.
  get processedByLabel() {
    if (this.processedBy === "CONSOLIDATOR") return "Consolidator";
    if (this.processedBy === "CLIENT_VIA_INTEGRATION") return "Client";
    return this.processedBy;
  }
}

export class UrgentDeliveryManagementRelabelListRequest {
  page = 1;
  limit = 20;
  sttNo = "";
  clientAggregatorType = "";
  productType = "";
  originCityCode = "";
  destinationCityCode = "";
  startDate = "";
  endDate = "";
  orderBy = "";
  sortBy = "";
  hubId = "0";

  constructor(fields?: Partial<UrgentDeliveryManagementRelabelListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class UrgentDeliveryManagementRelabelListRequestDownload {
  sttNo = "";
  clientAggregatorType = "";
  productType = "";
  originCityCode = "";
  destinationCityCode = "";
  startDate = "";
  endDate = "";
  orderBy = "";
  sortBy = "";

  constructor(
    fields?: Partial<UrgentDeliveryManagementRelabelListRequestDownload>
  ) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class UrgentDeliveryManagementDetailData {
  pdId = 0;
  pdSttNo = "";
  rpdRequestType = "";
  sttLastStatusId = "";
  pdDeadlineReturn = "";
  pdReason = "";
  pdCreatedAt = "";
  pdCreatedBy = "";
  pdCreatedRoleName = "";
  rpdLink = [];
  sttDestinationCity = "";
  rpdNotes = "";
  rpdProofPhoto = [];
  pdBkdDate = "";
  pdBkdByName = "";
  
  constructor(fields?: Partial<UrgentDeliveryManagementDetailData>) {
    Object.assign(this, fields);
  }

  get formatDeadline() {
    return this.pdDeadlineReturn === "-" ? "-" : formatDateWithoutTime(this.pdDeadlineReturn);
  }

  get formatCreatedAt() {
    return formatDate(this.pdCreatedAt);
  }

  get formatPdBkdDate() {
    return formatDateBasedTimezoneValue(
      this.pdBkdDate,
      "DD MMMM YYYY, HH:mm",
      true
    );
  }

  get formatCreatedAtNoTimeZone() {
    return formatDateBasedTimezoneValue(
      this.pdCreatedAt,
      "DD MMMM YYYY, HH:mm",
      true
    );
  }

  get createdBy() {
    const nameActor = this.pdCreatedBy || "";
    const roleActor = this.pdCreatedRoleName || "";

    if (nameActor.toLowerCase() === "system") return `• ${nameActor}`;
    if (nameActor && roleActor) return `• ${nameActor} • ${roleActor}`;
    else if (!roleActor && nameActor) return `• ${nameActor}`;
    else if (!nameActor && roleActor) return `• ${roleActor}`;

    return "";
  }
}
